import format from "date-fns/format";
import { truncate } from "../../util/format-text";
import { isoDateToString } from "../../util/format-date";

/** ========================================================================
 * * Charging Card Component
 * Renders a component, which summarizes EV charging details.
 * ========================================================================== */

export default function ChargingCard({ charging, selected, onClick }) {
  return (
    <div
      onClick={onClick && onClick}
      className={`grid items-center lg:grid-cols-6 gap-x-6 ${
        selected ? "selected-card" : "pill"
      }`}
    >
      <div className="flex items-center space-x-4">
        <p className="font-semibold text-stone-200">
          {charging.vehicle?.year} {charging.vehicle?.make?.name} {charging.vehicle?.model}{" "}
          {charging.vin?.slice(13, 17)}
        </p>
      </div>
      <div className="text-center">
        <p className="text-stone-200">
          {isoDateToString(charging.date, "MMM do, yyyy h:mm a")}
        </p>
      </div>
      <div className="text-center lg:col-span-2">
        <p className="text-stone-200">
          {truncate(charging.location, 50)}
        </p>
      </div>
      <div className="text-center">
        <p className={`${charging.invoiced ? "text-green-600" : "text-primary"} font-semibold`}>{charging.invoiced ? "Invoiced" : "Not Invoiced"}</p>
      </div>
      <div className="ml-auto text-center">
        <p className="font-semibold text-stone-200">${charging.total}</p>
      </div>
    </div>
  );
}
